import React from "react";
import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";
import StepCheckout from "components/Step/StepCheckout";
import { CreateDummyAccountResponseCamelCase } from "lib/api/account";
import { useFall25ExtCouponSync } from "utils/hooks/useFall25ExtCouponSync";

export const MembershipStepCheckout = ({
  onPhoneNumberChange,
  routePrevStep,
  routeNextStep,
  ...stepProps
}: MembershipState) => {
  useFall25ExtCouponSync();

  const backButtonProps = {
    onClick: () => routePrevStep?.(),
  };

  const handleAuthenticationSuccess = (
    _?: CreateDummyAccountResponseCamelCase,
    phoneNumber?: string
  ) => {
    onPhoneNumberChange?.(phoneNumber || "");
    return routeNextStep?.();
  };

  return (
    <StepCheckout
      {...stepProps}
      onAuthenticationSuccess={handleAuthenticationSuccess}
      stepFooterProps={{ backButtonProps }}
      stepHeaderProps={{ backButtonProps }}
    />
  );
};

export const MEMBERSHIP_STEP_CHECKOUT: MembershipStep = {
  component: MembershipStepCheckout,
  id: "membership-id-checkout",
  slug: "checkout",
};

export const MEMBERSHIP_STEP_CHECKOUT_CREATE_ACCOUNT: MembershipStep = {
  ...MEMBERSHIP_STEP_CHECKOUT,
  slug: "create-account",
};

export default MembershipStepCheckout;
